// removed by extract-text-webpack-plugin
module.exports = {"bg":"bg___31xBD","wrapper":"wrapper___X-Qha","header":"header___2a8ck","h3":"h3___3-opP","saving":"saving___Fw4PG","content":"content___60g_W","btnAdd":"btnAdd___1DCH-","create":"create___2rwk3","topBar":"topBar___I3-r2","col1":"col1___1seB4","col2":"col2___1Ux6f","topInput":"topInput___5q7jp","input":"input___2Ej6Z","extendedInput":"extendedInput___2tjv2","inputX":"inputX___oe7aK","bottomOptions":"bottomOptions___3Tc0i","bottomBtn":"bottomBtn___1wMYb"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/DataSource/styles.scss
// module id = 476
// module chunks = 0